import styled, { StyledProps } from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import { sm } from '@ucheba/utils/helpers/styles/mixins'
import {
  EModColor,
  EModFirstLetterUppercase,
  EModFontSize,
  EModFontWeight,
  EModLineHeight,
  EModNowrap,
  EModTextAlign,
  EModTextDecoration,
  EModUppercase,
  EModWordBreak,
  IModColor,
  IModFirstLetterUppercase,
  IModFontSize,
  IModFontWeight,
  IModLineHeight,
  IModNowrap,
  IModTextAlign,
  IModTextDecoration,
  IModUppercase,
  IModWordBreak,
} from '@ucheba/utils/helpers/styles/mod.types'

const Block = styled.div<
  StyledProps<
    IModFontWeight &
      IModFontSize &
      IModLineHeight &
      IModTextAlign &
      IModColor &
      IModUppercase &
      IModNowrap &
      IModTextDecoration &
      IModFirstLetterUppercase &
      IModWordBreak
  >
>`
  ${Object.keys(EModWordBreak).map(
    (item) => sm.mod(EModWordBreak[item])`
        word-break: ${item};
      `
  )};

  ${Object.keys(EModFontWeight).map(
    (item) => sm.mod(EModFontWeight[item])`
      font-weight: ${sv.fontWeight[item]};
    `
  )};

  ${Object.keys(EModFontSize).map(
    (item) => sm.mod(EModFontSize[item])`
      font-size: ${sv.fontSize[item]};
    `
  )};

  ${Object.keys(EModLineHeight).map(
    (item) => sm.mod(EModLineHeight[item])`
      line-height: ${sv.lineHeight[item]};
    `
  )};

  ${Object.keys(EModTextAlign).map(
    (item) => sm.mod(EModTextAlign[item])`
      text-align: ${item};
    `
  )};

  ${Object.keys(EModColor).map(
    (item) => sm.mod(EModColor[item])`
      color: ${sv.color[item]};
    `
  )};

  ${sm.mod(EModTextDecoration.lineThrough)`
    text-decoration: line-through;
  `};

  ${sm.mod(EModTextDecoration.underline)`
    text-decoration: underline;
  `};

  ${sm.mod(EModUppercase.true)`
    ${sm.font.uppercase};
  `};

  ${sm.mod(EModNowrap.true)`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `};

  ${sm.mod(EModFirstLetterUppercase.true)`
    &:first-letter {
      text-transform: uppercase;
    }
  `};

  display: inline-block;
  position: relative;
  width: 100%;

  label {
    z-index: 1;
    line-height: 1;
    position: absolute;
    left: ${sv.spacing.xsmall};
    top: ${sv.spacing.xsmall};
    color: ${sv.color.gray60};
    transition:
      top 0.3s,
      font-size 0.3s;
    background: #fff;

    &.active {
      font-size: ${sv.fontSize.xsmall2};
      padding: 2px ${sv.spacing.usmall};
      top: 0;
      transform: translateY(-50%);
      color: ${sv.color.blue} !important;
    }

    &.disabled {
      color: ${sv.color.gray25} !important;
    }

    &.error {
      color: ${sv.color.red} !important;
    }
  }

  &:hover {
    label {
      color: ${sv.color.cobalt};
    }
    textarea {
      border-color: ${sv.color.cobalt};
    }
  }
`

const Textarea = styled.textarea`
  display: block;
  resize: none;
  font: inherit;
  border-radius: 4px;
  width: 100%;
  height: 100%;
  padding: ${sv.spacing.xsmall};
  font-size: ${sv.fontSize.medium};
  border-color: ${sv.color.gray15};

  &:disabled {
    background: #fff;
    pointer-events: none;
    color: ${sv.color.gray25} !important;
    border-color: ${sv.color.gray9} !important;
  }

  &:focus {
    border-color: ${sv.color.blue} !important;
    color: ${sv.color.black} !important;
  }

  &.error {
    border-color: ${sv.color.red} !important;
  }
`

const Error = styled.div`
  color: ${sv.color.red};
`

const TextareaWrapper = styled.div`
  position: relative;
`

const TopGradient = styled.div`
  position: absolute;
  top: 1px;
  left: ${sv.spacing.xsmall};
  right: ${sv.spacing.xsmall};
  height: 12px;
  background: #fff;
  background: linear-gradient(
    0deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 1) 70%,
    rgba(255, 255, 255, 1) 100%
  );
`

const BottomGradient = styled.div`
  background: #fff;
  position: absolute;
  bottom: 1px;
  left: ${sv.spacing.xsmall};
  right: ${sv.spacing.xsmall};
  height: 8px;
  background: rgb(255, 255, 255);
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 1) 100%
  );
`

export default { Block, TextareaWrapper, Textarea, Error, TopGradient, BottomGradient }
